import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getHttpClient } from '../utils/request';
var request = getHttpClient();
export var getSession = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(uuid, currency, amount, country, participants, bookingData, paymentAccountId, checkoutHost) {
    var paymentDescription, returnUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paymentDescription = "".concat(participants.email, "/").concat(bookingData.eventId, "/").concat(bookingData.source, " ").concat(bookingData.prid || bookingData.promoterSlug, "/").concat(participants.firstName, " ").concat(participants.lastName, "/").concat(bookingData.venueName);
          returnUrl = window.location.href.split('#').slice(0, 2).join('#');
          if (returnUrl.includes('?')) {
            returnUrl = "".concat(returnUrl, "&bookingId=").concat(uuid);
          } else {
            returnUrl = "".concat(returnUrl, "?bookingId=").concat(uuid);
          }
          _context.next = 5;
          return request({
            url: "".concat(checkoutHost, "/v2/adyen/payments/payment-session"),
            method: 'POST',
            body: {
              country: country,
              amount: amount,
              currency: currency,
              channel: 'web',
              returnUrl: returnUrl,
              email: participants.email,
              paymentDescription: paymentDescription,
              bookingId: uuid,
              paymentAccountId: paymentAccountId
            }
          });
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSession(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();
export var confirmBooking = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(uuid, bookingData, apiHost, lang, accessToken) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          bookingData.bookingId = uuid;
          _context2.next = 3;
          return createFreeBooking(bookingData, apiHost, lang, accessToken);
        case 3:
          return _context2.abrupt("return", _context2.sent);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function confirmBooking(_x9, _x10, _x11, _x12, _x13) {
    return _ref2.apply(this, arguments);
  };
}();
export var createFreeBooking = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(bookingData, apiHost, lang, accessToken) {
    var authRequest, res, _yield$res$json, data, success, error;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          authRequest = getHttpClient(accessToken ? {
            Authorization: "Bearer ".concat(accessToken)
          } : {});
          _context3.next = 3;
          return authRequest({
            url: "".concat(apiHost, "/booking-attempt?lang=").concat(lang),
            method: 'POST',
            body: bookingData
          });
        case 3:
          res = _context3.sent;
          _context3.next = 6;
          return res.json();
        case 6:
          _yield$res$json = _context3.sent;
          data = _yield$res$json.data;
          success = _yield$res$json.success;
          error = _yield$res$json.error;
          if (!(res.status >= 400 || !success)) {
            _context3.next = 12;
            break;
          }
          throw new Error("Booking attempt failed: ".concat(error.message));
        case 12:
          return _context3.abrupt("return", data.bookingId);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function createFreeBooking(_x14, _x15, _x16, _x17) {
    return _ref3.apply(this, arguments);
  };
}();
export var updateBooking = function () {
  var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(apiHost, bookingId, additionalBookignDataData, accessToken) {
    var authRequest, res, _yield$res$json2, data, success, error;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          authRequest = getHttpClient(accessToken ? {
            Authorization: "Bearer ".concat(accessToken)
          } : {});
          _context4.next = 3;
          return authRequest({
            url: "".concat(apiHost, "/booking-attempt/").concat(bookingId),
            method: 'POST',
            body: additionalBookignDataData
          });
        case 3:
          res = _context4.sent;
          _context4.next = 6;
          return res.json();
        case 6:
          _yield$res$json2 = _context4.sent;
          data = _yield$res$json2.data;
          success = _yield$res$json2.success;
          error = _yield$res$json2.error;
          if (!(res.status >= 400 || !success)) {
            _context4.next = 12;
            break;
          }
          throw new Error("Booking update attempt failed: ".concat(error.message));
        case 12:
          return _context4.abrupt("return", data.bookingId);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function updateBooking(_x18, _x19, _x20, _x21) {
    return _ref4.apply(this, arguments);
  };
}();
export var confirmPayment = function () {
  var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(paymentId, redirectResult, checkoutHost, accessToken) {
    var authRequest, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          authRequest = getHttpClient(accessToken ? {
            Authorization: "Bearer ".concat(accessToken)
          } : {});
          _context5.next = 3;
          return authRequest({
            url: "".concat(checkoutHost, "/v2/adyen/payments/").concat(paymentId, "/additional-data"),
            method: 'POST',
            body: {
              redirectResult: redirectResult
            }
          });
        case 3:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 5:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function confirmPayment(_x22, _x23, _x24, _x25) {
    return _ref5.apply(this, arguments);
  };
}();
export var confirmPaymentResult = function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6(checkoutHost, paymentId, stateData) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return request({
            url: "".concat(checkoutHost, "/v2/adyen/payments/").concat(paymentId, "/payment-result"),
            method: 'POST',
            body: stateData
          });
        case 2:
          res = _context6.sent;
          _context6.next = 5;
          return res.json();
        case 5:
          return _context6.abrupt("return", _context6.sent);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function confirmPaymentResult(_x26, _x27, _x28) {
    return _ref6.apply(this, arguments);
  };
}();